
    var swiper = new Swiper('.swiper-container-Ourlook', {
      slidesPerView: 'auto',
      spaceBetween: 45,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var swiper_announcement = new Swiper('.swiper-container-announcement', {
       loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var swiper_products = new Swiper('.products_slider .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 0,
          loop: true,
           navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
      
  setTimeout(
    function() 
    {
    var swiper_recommendations  = new Swiper('.swiper-container.recommendation', {
        slidesPerView: 'auto',
        spaceBetween: 0,
            loop: true,
             navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }, 
    });    
  }, 5000);
 

/* Ziv Script Oct 24, 2023 */

function isMobileDevice() {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('Mobile') !== -1);
}

$(document).ready(function() {

  // Create a hover event over the hostspot button in the Timeless Design only on desktop
  if (!isMobileDevice()){
    if ($('.lg-hotspot__button').length > 0){
      $('.lg-hotspot__button').each(function(indx, val){
        $(val).on('mouseenter', function(){$(val).trigger('click')});
        $(val).on('mouseleave', function(){$(val).trigger('click')});
      });
    }  
  }
  
});




